import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import ParkinglocationModel from './ParkinglocationModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/location-forward/locations';

export default new class LocationForwardlocationsModel {

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get(BASE + '/' + id, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getAll(parkinglocationId = null) {
        var filter = { order: "name ASC" };
        if (parkinglocationId) {
            filter = _.merge(filter, { where: { and: [{ corelocationId: parkinglocationId }] } });
        }
        return new Promise((resolve, reject) => {
            axios.get(BASE, {
                params: {
                    access_token: UserModel.getAccessToken(),
                    filter: filter
                }
            })
                .then((response) => {
                    ParkinglocationModel.getAll(true)
                        .then((pl) => {
                            let data = [];
                            response.data.map(async (child, idx) => {
                                let location = _.find(pl, { id: child.corelocationId });
                                const id = child.id || child._id;
                                location
                                    ? data.push(Object.assign({}, child, { id, parkingLocationName: location.Code + ' - ' + location.Name }))
                                    : data.push(Object.assign({}, child, { id, parkingLocationName: 'Neznámá lokalita' }));
                            });
                            resolve(data);
                        });
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    create(data) {
        return new Promise((resolve, reject) => {
            axios.post(BASE, Object.assign({}, data), {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    remove(id) {
        return new Promise((resolve, reject) => {
            axios.delete(BASE + '/' + id, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    update(id, data) {
        if (data.id !== undefined) {
            delete data.id;
        }
        return new Promise((resolve, reject) => {
            axios.put(BASE + '/' + id, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    patch(id, data) {
        if (data.id !== undefined) {
            delete data.id;
        }
        if (data.confirmPassword !== undefined) {
            delete data.confirmPassword;
        }
        return new Promise((resolve, reject) => {
            axios.patch(BASE + '/' + id, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/LocationForwardlocationsModel.js